/* src/app/components/admin/accounts/export-accounts-dialog/export-accounts-dialog.component.scss */
.mat-mdc-dialog-title {
  padding: 24px 24px 24px 20px;
  margin: -24px -24px 10px -24px;
  background-color: rgb(48, 63, 159);
  color: white;
}
.radio-group {
  display: flex;
  flex-direction: column;
  margin: 15px;
}
.mat-mdc-radio-button {
  width: 100%;
  align-items: center;
  padding: 6px 16px;
}
/*# sourceMappingURL=export-accounts-dialog.component.css.map */
